"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    PackagedJwtService: ()=>PackagedJwtService
});
const external_jwt_service_js_namespaceObject = require("./jwt.service.js");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function packaged_jwt_service_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else packaged_jwt_service_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
class PackagedJwtService {
    saveJwt(uniqueKey, jwt) {
        if ('function' == typeof this.storageSet) {
            var _this_storageGet, _this;
            const data = (null == (_this_storageGet = (_this = this).storageGet) ? void 0 : _this_storageGet.call(_this)) || {};
            data[uniqueKey] = jwt;
            this.storageSet(data, uniqueKey);
        }
    }
    getService(uniqueKey) {
        if (!this.jwtServiceMap.has(uniqueKey)) {
            const config = this.jwtConfigs[uniqueKey];
            if (!config) {
                console.error('[PackagedJwtService] get jwt config failed', {
                    uniqueKey,
                    configs: this.jwtConfigs
                });
                throw new Error(`PackagedJwtService] get jwt config failed: ${uniqueKey}`);
            }
            this.jwtServiceMap.set(uniqueKey, new external_jwt_service_js_namespaceObject.BaseJwtService(_object_spread_props(_object_spread({
                uniqueKey
            }, config), {
                saveJwt: (jwt)=>{
                    this.saveJwt(uniqueKey, jwt);
                },
                setPromiseCache: (content)=>{
                    this.promiseCacheObject[uniqueKey] = content;
                },
                getPromiseCache: ()=>this.promiseCacheObject[uniqueKey],
                resetJwt: ()=>{
                    var _this_storageSet, _this;
                    null == (_this_storageSet = (_this = this).storageSet) || _this_storageSet.call(_this, {});
                }
            })));
        }
        return this.jwtServiceMap.get(uniqueKey);
    }
    setCache(uniqueKey, jwt) {
        this.promiseCacheObject[uniqueKey] = Promise.resolve(jwt);
        this.saveJwt(uniqueKey, jwt);
    }
    getJwt(uniqueKey) {
        return this.getService(uniqueKey).getJwt();
    }
    logout(uniqueKey, next) {
        return this.getService(uniqueKey).logout(next);
    }
    constructor({ items, storageGet, storageSet, promiseCacheObject }){
        _define_property(this, "jwtServiceMap", new Map());
        _define_property(this, "jwtConfigs", void 0);
        _define_property(this, "promiseCacheObject", void 0);
        _define_property(this, "storageSet", void 0);
        _define_property(this, "storageGet", void 0);
        this.jwtConfigs = items;
        this.promiseCacheObject = promiseCacheObject || {};
        this.storageSet = storageSet;
        this.storageGet = storageGet;
        const data = null == storageGet ? void 0 : storageGet();
        if (data) Object.keys(data).forEach((key)=>{
            const token = data[key];
            if (token) this.promiseCacheObject[key] = Promise.resolve(token);
        });
    }
}
exports.PackagedJwtService = __webpack_exports__.PackagedJwtService;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "PackagedJwtService"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
